import {
  OTPRegistrationRequest,
  OTPRegistrationResponse,
} from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../../axios';

const registerOtvcUser = async (requestBody: OTPRegistrationRequest) => {
  const { data } = await axios.post<OTPRegistrationResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/otp/registration`,
    requestBody
  );

  return data;
};

export const useRegisterOtvcUserMutation = () =>
  useMutation({
    mutationFn: (requestBody: OTPRegistrationRequest) =>
      registerOtvcUser(requestBody),
  });
